import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Checkbox } from 'antd';
// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

// import Loading from '../../components/Loading';
function CollectCage({ onChange, onSubmit, onCancel, cage, continueWithoutCage }) {
  return (
    <div>
      <Row style={{ flexWrap: 'nowrap' }}>
        <Col style={{ marginTop: '16px' }}>
          {/* <!-- LOADING --> */}
          {/* <!-- CONTENT --> */}
          <div className="nf-registration__content">
            <Row className="nf-row--justify-end" />
            {/* <!-- USERS GRID --> */}
            <div className="nf-registration__layout">
              {/* <div className="nf-registration__input">
                <p>{msgs.Registration.user.Email}</p>
                <input
                  type="text"
                  placeholder="Email"
                  name="emailAddress"
                  onChange={onChange}
                  className="input-registration"

                />
              </div> */}
              <div className="nf-registration__input">
                <p> CAGE Code</p>
                <input
                  disabled={continueWithoutCage}
                  type="text"
                  placeholder="CAGE"
                  name="cageCode"
                  onChange={onChange}
                  className="input-registration"
                />
              </div>

              <div className="cage-checkbox-wrapper">
                <Checkbox
                  name="continueWithoutCage"
                  onChange={onChange}
                  disabled={cage}
                  style={{ textAlign: 'left' }}
                >
                  I do not have a valid CAGE Code and understand that I will
                  not be able to bid directly on solicitations from the DLA
                </Checkbox>
              </div>

              <div className="nf-registration--wrapper">
                <div className="nf-registration__buttons">
                  <NFButton
                    className="nf-button--gray-border"
                    style={{ marginRight: '16px' }}
                    onClick={() => {
                      onCancel();
                    }}
                  >
                    {msgs.Form.cancelButton}
                  </NFButton>
                  <NFButton
                    disabled={!cage && !continueWithoutCage}
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    onClick={() => {
                      onSubmit();
                    }}
                  >
                    {msgs.Form.continueButton}
                  </NFButton>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

CollectCage.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cage: PropTypes.string.isRequired,
  continueWithoutCage: PropTypes.bool.isRequired,
};

export default CollectCage;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/CollectCage/CollectCage.jsx